// extracted by mini-css-extract-plugin
module.exports = {"date-input":"AddEvent_date-input__1LYM8","time-input":"AddEvent_time-input__1kyFY","blue-background":"AddEvent_blue-background__FFvp_"};